import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CampaignContext } from "../../contexts/CampaignContext";
import { IconJsxer } from "../../helpers/IconHelper";
import axios from "../../api/axios";
import { getCampaignAnalyticDataRoute } from "../../api/routes";
import { toast } from "react-toastify";
import CampaignAnalytics from '../Analytics/CampaignAnalytics';
import StreamAnalyticsSummary from '../Analytics/StreamAnalyticsSummary';
import "./AnalyticsDropdown.scss";

const AnalyticsDropdown = ({ isOpen, onClose, openSessionAnalytics }) => {
    const [campaignContext] = useContext(CampaignContext);
    const [campaignSummaryAnalytics, setCampaignSummaryAnalytics] = useState([]);
    const [analyticsData, setAnalyticsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [noStreamsRecorded, setNoStreamsRecorded] = useState(false);

    useEffect(() => {
        if (isOpen && campaignContext.campaignData?._id) {
            getCampaignAnalyticData();
        }
    }, [isOpen, campaignContext.campaignData?._id]);

    const getCampaignAnalyticData = () => {
        setLoading(true);
        setNoStreamsRecorded(false);
        axios
            .get(getCampaignAnalyticDataRoute, {
                params: { campaignID: campaignContext.campaignData._id },
                withCredentials: true
            })
            .then(function (response) {
                const analytics = response.data.analyticsData;

                // If there is no analytics data or no streams yet, show friendly message
                if (!analytics || !analytics.streams || analytics.streams.length === 0) {
                    setAnalyticsData(analytics || null);
                    setCampaignSummaryAnalytics([]);
                    setNoStreamsRecorded(true);
                    setLoading(false);
                    return;
                }

                setAnalyticsData(analytics);
                setCampaignSummaryAnalytics(analytics.streams);
                setLoading(false);
            })
            .catch(function (error) {
                // Only show a toast for real errors, not "no data" cases
                toast.error('Error loading analytics - ' + error);
                setLoading(false);
            });
    };

    if (!isOpen) return null;

    return (
        <>
            {createPortal(
                <div className="analytics-dropdown-overlay" onClick={onClose}></div>,
                document.body
            )}
            <div className="analytics-dropdown">
                <div className="analytics-dropdown-header">
                    <h3>Campaign Analytics</h3>
                    <button className="close-button" onClick={onClose}>
                        {IconJsxer.GetIcon(IconJsxer.ICONS.closeX)}
                        <span>Close</span>
                    </button>
                </div>

                <div className="analytics-content">
                    {loading ? (
                        <div className="loading-message">Loading analytics...</div>
                    ) : noStreamsRecorded ? (
                        <div className="no-streams-message">No Streams Recorded</div>
                    ) : (
                        <>
                            <CampaignAnalytics
                                _campaignAnalyticsSummary={campaignSummaryAnalytics}
                                _campaignName={campaignContext.campaignData.campaignName}
                                _client={campaignContext.campaignData.client}
                                _numberOfStreams={campaignContext.campaignData.streams?.length || 0}
                                _gridLayout="2-rows"
                            />
                            {campaignContext.campaignData.streams?.map((stream, i) => (
                                <div className="stream-summary-panel" key={'str_' + i}>
                                    <StreamAnalyticsSummary
                                        _setCampaignDataFunc={setCampaignSummaryAnalytics}
                                        _analyticsData={analyticsData}
                                        _campaignAnalyticsSummary={campaignSummaryAnalytics}
                                        _streamID={stream._id}
                                        _streamName={stream.name}
                                        _channels={stream.channels}
                                        _twitchHandle={stream.twitchHandle}
                                        _startTime={stream.startTime}
                                        _campaignID={campaignContext.campaignData._id}
                                        _endTime={stream.endTime}
                                        _timeZone={stream.timeZone}
                                        _openSessionAnalytics={openSessionAnalytics}
                                    />
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default AnalyticsDropdown;
